import { render, staticRenderFns } from "./PaymentSucceeded.vue?vue&type=template&id=2275ebba&scoped=true&"
import script from "./PaymentSucceeded.vue?vue&type=script&lang=js&"
export * from "./PaymentSucceeded.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSucceeded.vue?vue&type=style&index=0&id=2275ebba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2275ebba",
  null
  
)

export default component.exports